module.exports = __webpack_public_path__ + "static/media/box-container-v-flipped.8c37c777.png";